<template>
  <div class="row m-t-10">
    <div class="col-md-12 px-gap">
      <div class="card m-b-10 shade">
        <div class="card-body">
          <div class="row">
            <div class="col-md-8 col-sm-12">
              <div class="pull-left m-t-5 m-b-5">
                <h4 class="m-b-0">Grafik Tendency Bar</h4>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <highcharts :options="dataBar" :ref="barchart_id"></highcharts>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-dynamic-component
      v-if="currentModal"
      :key="modal_key"
      :modal="currentModal"
      :data="modal_data"
      :static="true"
      :modal_size="modal_size"
    />
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_tendency from "@/views/components/analytics/media-tendency/modal_tendency.vue";

export default {
  name: "tendency_bar",
  components: {
    highcharts: Chart,
    "modal-dynamic-component": modal_dynamic,
  },
  props: {
    data: {
      default: null,
      type: Object,
    },
    barchart_id: String,
  },
  data() {
    return {
      dataBar: {},
      ids: null,
      modal_key: 0,
      modal_data: [],
      currentModal: null,
      modal_size: "modal-lg",
    };
  },
  methods: {
    optionBar: function () {
      let self = this;
      this.dataBar = {
        chart: {
          type: "bar",
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: [
            "-F",
            "-E",
            "-D",
            "-C",
            "-B",
            "-A",
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
          ],
          title: {
            text: null,
          },
        },
        yAxis: {
          min: 0,
          labels: {
            overflow: "justify",
          },
          title: {
            text: "Jumlah Akun",
          },
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
            },
          },
          series: {
            cursor: "pointer",
            point: {
              events: {
                click: function (e) {
                  let category = e.point.category;
                  self.viewDataCategory(e, category);
                },
              },
            },
          },
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Kelas",
            data: [
              self.data.graph[0].y,
              self.data.graph[1].y,
              self.data.graph[2].y,
              self.data.graph[3].y,
              self.data.graph[4].y,
              self.data.graph[5].y,
              self.data.graph[6].y,
              self.data.graph[7].y,
              self.data.graph[8].y,
              self.data.graph[9].y,
              self.data.graph[10].y,
              self.data.graph[11].y,
            ],
          },
        ],
      };
    },
    viewDataCategory: function (self, category) {
      var view_data = {
        title: "Detail Tendency " + category,
        component: modal_tendency,
      };
      let dataCategory = {
        data: this.data,
        category: category,
      };
      this.currentModal = view_data;
      this.modal_data = dataCategory;
      this.modal_key++;
    },
  },
  mounted() {
    if (this.data) {
      this.optionBar();
    }
  },
};
</script>